module.exports = "<div class=\"title-outer\" [ngStyle]=\"{'text-align': align, 'flex-direction': statusInline ? 'row' : 'column', 'margin': margin}\">\r\n  <span *ngIf=\"statusVisible\" class=\"status\" [ngStyle]=\"{'background-color': statusColor, 'margin-right': statusInline ? '10px' : '0', 'margin-bottom': statusInline? '0px': '10px'}\"></span>\r\n  <h3 class=\"title\" [ngStyle]=\"{'font-size': fontSize + 'px'}\">{{ title }}</h3>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/stats/title/title.component.html
// module id = ./src/app/components/stats/title/title.component.html
// module chunks = main